import React from 'react';
import { Placemark } from 'react-yandex-maps';
import caption from 'assets/images/map/cluster.svg';
import './style.css';

const YClusterPoint = React.memo(({ lat, lng, pointCount, onClick }) => (
  <Placemark
    geometry={[+lat, +lng]}
    properties={{
      iconContent: `<div class="ClusterPoint>" style="display: flex;align-items: center;justify-content: center;width: 34px;height: 34px;border: 3px solid #FFF;border-radius: 34px;background-color: #085286;text-align: center;line-height: 28px;font-size: 1.2rem;font-weight: 700;color: #FFF;box-shadow: 0 0 0.2rem rgba(0,0,0,0.3);transition: all 0.25s ease-in-out;">${pointCount}</div`
    }}
    onClick={onClick}
    options={{
      iconLayout: 'default#imageWithContent',
      iconImageSize: [34, 34],
      iconImageOffset: [-17, -17],
      iconImageHref: caption
    }}
  />
));

export default YClusterPoint;



// WEBPACK FOOTER //
// ./src/components/common/YMap/YClusterPoint/index.js